import React from 'react';
import AddNotes from '../ReusedComponents/AddNotes'

export default function AddNotesP() {
  return (
    <AddNotes type={"admin"} />
  );
}
